<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col cols="12">
        <!-- <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('itSolutions.development.title') }}
          </v-col>
        </v-row> -->
        <v-row>

          <!-- unique software -->
          <v-col cols="12" md="6" class="pb-0">
            <v-row>
              <v-col>
                <!-- <v-icon>mdi-draw</v-icon> -->
                <svg  height="80" width="80" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 121.74" style="enable-background:new 0 0 122.9 120.5;fill-rule:evenodd;clip-rule:evenodd;" class="mb-2" xml:space="preserve">
                  <g>
                    <path :d="svg.softwareDevelopment"></path>
                  </g>
                </svg>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('itSolutions.softwareDevelopment.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('itSolutions.softwareDevelopment.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.softwareDevelopment != 0"
                  text color="primary"
                  @click="panel.softwareDevelopment = 0">
                  {{ $t('common.readMore')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel.softwareDevelopment"
              accordion flat
              class="no-gutter">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <v-col class="pa-0 text-justify">
                    <!-- {{ $t('itSolutions.softwareDevelopment.text.01')}}<br> -->
                    {{ $t('itSolutions.softwareDevelopment.text.02')}}<br>
                    {{ $t('itSolutions.softwareDevelopment.text.03')}}
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.softwareDevelopment == 0"
                  text color="primary"
                  @click="panel.softwareDevelopment = null">
                  {{ $t('common.close')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- modular software -->
          <v-col cols="12" md="6" class="pb-0">
            <v-row>
              <v-col>
                <!-- <v-icon>mdi-puzzle-outline</v-icon> -->
                <svg  height="80" width="80" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 121.74" style="enable-background:new 0 0 122.9 120.5;fill-rule:evenodd;clip-rule:evenodd;" class="mb-2" xml:space="preserve">
                  <g>
                    <path :d="svg.modularSoftware"></path>
                  </g>
                </svg>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('itSolutions.modularSoftware.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('itSolutions.modularSoftware.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.modularSoftware != 0"
                  text color="primary"
                  @click="panel.modularSoftware = 0">
                  {{ $t('common.readMore')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel.modularSoftware"
              accordion flat
              class="no-gutter">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <v-col class="pa-0 text-justify">
                    {{ $t('itSolutions.modularSoftware.text.01')}}<br>
                    {{ $t('itSolutions.modularSoftware.text.02')}}<br>
                    {{ $t('itSolutions.modularSoftware.text.03')}}<br>
                    {{ $t('itSolutions.modularSoftware.text.04')}}
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.modularSoftware == 0"
                  text color="primary"
                  @click="panel.modularSoftware = null">
                  {{ $t('common.close')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
        <v-divider></v-divider>
        <v-row class="pt-6">

          <!-- waterfall -->
          <v-col cols="12" md="6" class="pb-0">
            <v-row>
              <v-col>
                <!-- <v-icon>mdi-puzzle-outline</v-icon> -->
                <svg  height="80" width="80" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 121.74" style="enable-background:new 0 0 122.9 120.5;fill-rule:evenodd;clip-rule:evenodd;transform: scaleX(-1);" class="mb-2" xml:space="preserve">
                  <g>
                    <path :d="svg.waterFall"></path>
                  </g>
                </svg>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('itSolutions.process.waterFall.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('itSolutions.process.waterFall.text.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.waterFall != 0"
                  text color="primary"
                  @click="panel.waterFall = 0">
                  {{ $t('common.readMore')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel.waterFall"
              accordion flat
              class="no-gutter">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <v-col class="pa-0 text-justify">
                    {{ $t('itSolutions.process.waterFall.text.02')}}<br>
                    {{ $t('itSolutions.process.waterFall.text.03')}}
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.waterFall == 0"
                  text color="primary"
                  @click="panel.waterFall = null">
                  {{ $t('common.close')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- agile -->
          <v-col cols="12" md="6" class="pb-0">
            <v-row>
              <v-col>
                <!-- <v-icon>mdi-puzzle-outline</v-icon> -->
                <svg  height="80" width="80" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 121.74" style="enable-background:new 0 0 122.9 120.5;fill-rule:evenodd;clip-rule:evenodd;" class="mb-2" xml:space="preserve">
                  <g>
                    <path :d="svg.agile"></path>
                  </g>
                </svg>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('itSolutions.process.agile.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('itSolutions.process.agile.text.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.agile != 0"
                  text color="primary"
                  @click="panel.agile = 0">
                  {{ $t('common.readMore')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel.agile"
              accordion flat
              class="no-gutter">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <v-col class="pa-0 text-justify">
                    {{ $t('itSolutions.process.agile.text.02')}}<br>
                    {{ $t('itSolutions.process.agile.text.03')}}
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row>
              <v-col>
                <v-btn
                  v-if="panel.agile == 0"
                  text color="primary"
                  @click="panel.agile = null">
                  {{ $t('common.close')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'SoftwareDevelopment',
    extends: DataComponentBase,

    data: () => ({
      panel: {
        softwareDevelopment: null,
        modularSoftware: null,
        waterFall: null,
        agile: null,
      },
      svg: {
        softwareDevelopment: "M3.54,84.57c0.94-1.12,1.97-2.02,3.09-2.76c2.25-1.49,4.79-2.28,7.67-2.81c0-25.14,0-50.27,0-75.41 C3.39,4.66,3.46,14.75,3.52,24.12c0.01,1.26,0.02,1.92,0.02,2.23V84.57L3.54,84.57z M42.98,25.55h19.44l1.51,0v1.51v71.53v1.51 h-1.51H42.98h-1.51v-1.51V27.06v-1.51L42.98,25.55L42.98,25.55z M46.91,91.58h4.04v2.11h-4.04V91.58L46.91,91.58z M46.91,85.64 h4.04v2.11h-4.04V85.64L46.91,85.64z M46.91,79.7h4.04v2.11h-4.04V79.7L46.91,79.7z M46.91,73.75h4.04v2.11h-4.04V73.75 L46.91,73.75z M46.91,67.81h6.71v2.11h-6.71V67.81L46.91,67.81z M46.91,61.87h4.04v2.11h-4.04V61.87L46.91,61.87z M46.91,55.92 h4.04v2.11h-4.04V55.92L46.91,55.92z M46.91,49.98h4.04v2.11h-4.04V49.98L46.91,49.98z M46.91,44.04h4.04v2.11h-4.04V44.04 L46.91,44.04z M46.91,38.09h4.04v2.11h-4.04V38.09L46.91,38.09z M46.91,32.15h6.71v2.11h-6.71V32.15L46.91,32.15z M60.91,28.56 H44.49v68.51h16.42V28.56L60.91,28.56z M91.96,40.51v58.56H78.09V40.51h-0.06l0.47-0.96l5.73-11.77l0.58-1.2l0.61,1.18l6.1,11.77 l0.51,0.98H91.96L91.96,40.51z M80.18,39.16h9.66l-3.84-7.4h-2.22L80.18,39.16L80.18,39.16z M17.8,14.33h102.23 c0.79,0,1.5,0.32,2.02,0.84c0.52,0.52,0.84,1.23,0.84,2.02v90.95c0,0.78-0.32,1.49-0.84,2.01l-0.01,0.01h0 c-0.52,0.52-1.23,0.84-2.01,0.84H15.73c-4.27,0-10.19-3.35-12.66-6.88c-2.42-3.44-3.29-7.86-3.03-13.01V26.35c0-1.79,0-1.98,0-2.22 C-0.04,12.67-0.12,0.28,15.85,0.01C15.92,0,15.98,0,16.05,0c0.97,0,1.75,0.78,1.75,1.75V14.33L17.8,14.33z M3.52,91.53 c-0.18,4.28,0.52,7.88,2.41,10.57c1.9,2.71,5.09,4.58,9.92,5.39h103.54V17.82H17.8v62.64h-0.01c0,0.85-0.61,1.59-1.48,1.72 c-3.04,0.47-5.64,1.13-7.76,2.53C6.53,86.05,4.86,88.15,3.52,91.53L3.52,91.53z",
        modularSoftware: "M30.07,65.39l-0.71,20.73l-7.81-5.32l-7.81,4.41l1.61-22.22L4.29,61.47v46.58l40.74,4.63V67.05L30.07,65.39L30.07,65.39z M97.89,5.95c0.42-0.08,0.85,0,1.21,0.22c0.61,0.25,1.04,0.85,1.05,1.56l0.35,47.99l17.89,2.35v0c0.42-0.08,0.85,0,1.21,0.22 c0.61,0.25,1.04,0.85,1.05,1.56l0.35,49.19c0.03,0.6-0.27,1.2-0.82,1.53l-20.09,11.98c-0.28,0.21-0.64,0.34-1.02,0.34 c-0.09,0-0.19-0.01-0.27-0.02l-52.13-5.8c-0.13-0.01-0.25-0.03-0.37-0.06l-44.67-5.74c-0.9-0.04-1.61-0.79-1.61-1.69V59.55h0 c-0.02-0.67,0.36-1.32,1.01-1.6L24.55,47.6V13.24h0c-0.02-0.67,0.36-1.32,1.01-1.6l26.15-11.5l0,0c0.27-0.12,0.58-0.17,0.9-0.13 L97.89,5.95L97.89,5.95L97.89,5.95z M98.88,58.92l-15.72,9.38l15.61,1.99l14.95-9.42L98.88,58.92L98.88,58.92z M24.55,55.64V51.3 L7.87,58.63l9.57,1.22L24.55,55.64L24.55,55.64z M80.26,21.83v44.26l15.01-8.96l1.83-1.55l-0.32-44.16L80.26,21.83L80.26,21.83 L80.26,21.83z M75.96,67.18V21.4l-21.33-2.84L53.9,39.81l-7.81-5.32l-7.81,4.41l1.61-22.22l-11.96-1.53v46.58L75.96,67.18 L75.96,67.18L75.96,67.18z M73.35,6.15l-16.4,9.31l21.33,2.72l14.95-9.42L73.35,6.15L73.35,6.15L73.35,6.15z M41.99,13.54 l15.9-9.43l-5.24-0.69l-20.23,8.89L41.99,13.54L41.99,13.54z M100.75,73.94v44.26l16.85-10.05l-0.33-44.62L100.75,73.94 L100.75,73.94L100.75,73.94z M96.45,119.29V73.51l-21.33-2.84l-0.73,21.25l-7.81-5.32l-7.81,4.41l1.61-22.22l-11.06-1.08v46.58 L96.45,119.29L96.45,119.29L96.45,119.29z",
        waterFall: "M6.52,91.32c0,1.8-1.46,3.26-3.26,3.26c-1.8,0-3.26-1.46-3.26-3.26V73.45c0-0.11,0.01-0.22,0.02-0.32 c0.05-1.86,0.64-3.37,1.75-4.55c1.16-1.23,2.74-1.93,4.72-2.14c0.17-0.02,0.34-0.02,0.51-0.01l22.24,0.04V49.07 c0-0.11,0.01-0.22,0.02-0.33c0.05-1.17,0.41-2.17,1.1-2.98c0.85-1,2-1.52,3.44-1.55l0.09,0V44.2h24.66V27.61 c0-0.17,0.01-0.34,0.04-0.51c0.14-1.42,0.7-2.53,1.59-3.38c0.91-0.87,2.04-1.33,3.33-1.49c0.13-0.02,0.26-0.02,0.38-0.02l25.08,0 c0-5.09,0.28-10.99,0-15.99c0-0.95,0.32-2.38,1.11-3.58c0.9-1.37,2.34-2.5,4.5-2.63L94.93,0h24.69c1.8,0,3.26,1.46,3.26,3.26 c0,1.8-1.46,3.26-3.26,3.26H95.49v18.95c0,1.8-1.46,3.26-3.26,3.26H65.06v18.73c0,1.8-1.46,3.26-3.26,3.26H35.76v19h-0.01 c0,1.79-1.45,3.25-3.25,3.25L7.03,72.92C6.72,72.96,6.54,73,6.5,73.03l0,0.09c0.01,0.11,0.02,0.21,0.02,0.32V91.32L6.52,91.32z",
        agile: "M10.03,35.673c2.245-10.496,7.201-19.176,14.246-25.362C32.504,3.086,43.498-0.674,56.271,0.1 c1.916,0.113,3.377,1.758,3.265,3.674c-0.113,1.916-1.757,3.378-3.673,3.265C44.988,6.379,35.71,9.509,28.848,15.535 c-6.483,5.693-10.883,14.028-12.512,24.258l0.639,0.264l10.389-7.172c1.425-0.986,3.38-0.63,4.367,0.795 c0.986,1.426,0.63,3.381-0.795,4.366l-16.557,11.43c-1.425,0.986-3.38,0.63-4.366-0.795c-0.062-0.089-0.118-0.18-0.169-0.272 L9.84,48.409L0.39,31.146c-0.836-1.52-0.282-3.431,1.238-4.267c1.52-0.836,3.43-0.282,4.266,1.238L10.03,35.673L10.03,35.673z M99.032,23.108l-0.206,0.159l1.016,12.583c0.142,1.728-1.145,3.243-2.872,3.384c-1.727,0.142-3.242-1.145-3.384-2.872 L91.967,16.31c-0.142-1.728,1.144-3.243,2.871-3.384c0.108-0.009,0.215-0.013,0.32-0.011l0.001-0.002l19.675,0.446 c1.734,0.036,3.112,1.471,3.076,3.206c-0.035,1.734-1.471,3.111-3.206,3.075l-9.65-0.219c3.769,4.437,6.799,9.422,9.01,14.762 c2.775,6.698,4.243,13.922,4.243,21.281c0,3.63-0.358,7.25-1.064,10.812c-0.7,3.535-1.755,7.021-3.153,10.409 c-0.729,1.773-2.757,2.62-4.53,1.891c-1.773-0.729-2.619-2.757-1.891-4.529c1.207-2.924,2.125-5.974,2.745-9.104 c0.616-3.104,0.928-6.279,0.928-9.478c0-6.476-1.279-12.804-3.698-18.643C105.583,31.85,102.684,27.207,99.032,23.108 L99.032,23.108z M72.658,109.86c-5.729,1.047-11.558,1.181-17.277,0.427c-7.172-0.943-14.162-3.288-20.552-6.978l-0.01-0.006 l-0.003,0.006c-3.14-1.813-6.097-3.934-8.832-6.328c-2.73-2.392-5.223-5.045-7.437-7.923c-1.172-1.519-0.892-3.699,0.625-4.871 s3.699-0.892,4.871,0.626c1.948,2.533,4.131,4.857,6.512,6.943c2.377,2.082,4.97,3.939,7.743,5.54l-0.003,0.006 c5.588,3.225,11.705,5.274,17.983,6.101c5.35,0.705,10.824,0.517,16.196-0.593l-0.035-0.264l-11.405-5.411 c-1.566-0.741-2.236-2.612-1.495-4.179c0.741-1.567,2.613-2.236,4.18-1.495l18.177,8.624c1.566,0.741,2.235,2.612,1.494,4.18 c-0.046,0.097-0.097,0.191-0.15,0.282l0.002,0.001l-10.225,16.816c-0.898,1.483-2.83,1.959-4.314,1.061 c-1.484-0.897-1.96-2.829-1.062-4.313L72.658,109.86L72.658,109.86z",
      }
    }),

    methods: {

    },
  }
</script>
